import { useQuery } from 'react-apollo';
import { useMemo } from 'react';
import { intersection, uniq } from 'lodash';
import { filterOptionToCategory, IdeaFilterOption } from 'consts/ideaOptions';
import { IdeaFilterListQuery as Query } from './__generated__/IdeaFilterListQuery';
import * as query from './query.gql';

const alwaysVisible = [IdeaFilterOption.All, IdeaFilterOption.IPO];

const allOptions = Object.keys(filterOptionToCategory) as (keyof typeof filterOptionToCategory)[];

export const useTabs = () => {
  const { loading, data } = useQuery<Query>(query, {
    fetchPolicy: 'cache-first',
  });

  const tabs = useMemo(() => {
    const categories = uniq(data?.lab.ideas.map(({ category }) => category) || []);
    return allOptions.filter(
      (option) =>
        alwaysVisible.includes(option) ||
        intersection(filterOptionToCategory[option], categories).length
    );
  }, [data, loading]);

  return {
    tabs,
    loading,
  };
};
